import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as MainRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import './style/index.scss';
import './style/settings/settings.scss'

const basename = (process.env.PUBLIC_URL || '').replace(/\/+$/, '')
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <MainRouter basename={basename}>
        <App/>
      </MainRouter>
    </HelmetProvider>
  </React.StrictMode>
)



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
